import { Configuration, RedirectRequest, LogLevel } from '@azure/msal-browser'

// MSAL configuration for the production app (guardian.iuvotech.com).
// Authority defaults to /organizations so users from any consented Entra
// tenant can sign in. No domain_hint — MSAL shows its tenant selector when
// it cannot infer the tenant from cache or a login_hint.
export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID || '8c071a46-dbd9-4d18-9516-4abc0451651b',
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_TENANT_ID || 'organizations'}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return
        switch (level) {
          case LogLevel.Error:
            console.error(message)
            break
          case LogLevel.Info:
            console.info(message)
            break
          case LogLevel.Verbose:
            console.debug(message)
            break
          case LogLevel.Warning:
            console.warn(message)
            break
        }
      },
    },
  },
}

// Login request - include API scope in initial login
export const loginRequest: RedirectRequest = {
  scopes: [
    'User.Read',
    'openid',
    'profile',
    import.meta.env.VITE_FUNCTION_APP_SCOPE || 'api://8c071a46-dbd9-4d18-9516-4abc0451651b/user_impersonation'
  ],
  prompt: 'select_account'
}

// Token request for API access to Function App
export const tokenRequest = {
  scopes: [import.meta.env.VITE_FUNCTION_APP_SCOPE || 'api://8c071a46-dbd9-4d18-9516-4abc0451651b/user_impersonation']
}

// API request scopes for Function App
export const apiRequest = {
  scopes: [import.meta.env.VITE_FUNCTION_APP_SCOPE || 'api://8c071a46-dbd9-4d18-9516-4abc0451651b/user_impersonation']
}

// Graph API scopes for user profile (optional)
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
  graphMePhotoEndpoint: 'https://graph.microsoft.com/v1.0/me/photo/$value'
}
